<template>
  <div class="default__container">
    <v-container class="order-details">
      <div class="header">
        <h1 class="header__title">{{ $t("message.payments.title") }}</h1>
        <router-link
          class="header__back-btn"
          :to="{
            name: 'dashboard',
          }"
        >
          <v-icon class="header__back-icon" size="16">mdi-close</v-icon>
          {{ $t("message.serviceUnavailable.backToMainPage") }}
        </router-link>
      </div>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import { intercomMixin } from "@/helpers/mixins/intercom";

export default {
  name: "PaymentLayout",
  mixins: [intercomMixin],
  async created() {
    await this.setIntercom();
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  gap: $spacing * 3;
  padding: 0 $spacing * 2;

  &__title {
    @include font-size(30px);
  }

  &__back-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: $spacing * 0.5;
    margin-left: auto;
    height: 32px;
    padding: 0 12px;
    border: 1px solid $gray-300;
    border-radius: 40px;
    color: #1b323d;
    background: transparent;
    text-decoration: none;
    @include font-size(12px);
    transition-property: color, background;
    transition-duration: 0.2s;

    &:hover {
      color: white;
      background: $primary;
      border-color: $primary;

      .header__back-icon {
        color: white;
      }
    }
  }

  &__back-icon {
    color: #1b323d;
  }
}
.order-details {
  max-width: 750px;
  display: flex;
  flex-direction: column;
  padding: $spacing * 2;
}
</style>
